module.exports = __webpack_public_path__ + "img/coupon_648_100.93e17cd3.png";